import type { DemoScript } from "../types";
import { CALENDAR_SCRIPT_COPY } from "./calendar-script.copy";

export const buildCalendarScript = (): DemoScript => [
  {
    id: "cal-intro",
    narrative: CALENDAR_SCRIPT_COPY.calIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "cal-grid",
    narrative: CALENDAR_SCRIPT_COPY.calGrid.narrative,
    zoomTargetId: "calendar-month-grid",
    callout: {
      targetId: "calendar-month-grid",
      text: CALENDAR_SCRIPT_COPY.calGrid.callout,
    },
    durationMs: 5400,
  },
  {
    id: "cal-event-detail",
    narrative: CALENDAR_SCRIPT_COPY.calEventDetail.narrative,
    zoomTargetId: "calendar-event-detail",
    disableZoom: true,
    callout: {
      targetId: "calendar-event-detail",
      text: CALENDAR_SCRIPT_COPY.calEventDetail.callout,
    },
    durationMs: 5200,
  },
  {
    id: "cal-post-detail",
    narrative: CALENDAR_SCRIPT_COPY.calPostDetail.narrative,
    zoomTargetId: "calendar-post-detail",
    disableZoom: true,
    callout: {
      targetId: "calendar-post-detail",
      text: CALENDAR_SCRIPT_COPY.calPostDetail.callout,
    },
    durationMs: 5400,
  },
  {
    id: "cal-create",
    narrative: CALENDAR_SCRIPT_COPY.calCreate.narrative,
    zoomTargetId: "calendar-create-chooser",
    disableZoom: true,
    callout: {
      targetId: "calendar-create-chooser",
      text: CALENDAR_SCRIPT_COPY.calCreate.callout,
    },
    durationMs: 4800,
  },
  {
    id: "cal-event-form",
    narrative: CALENDAR_SCRIPT_COPY.calEventForm.narrative,
    zoomTargetId: "calendar-event-form",
    disableZoom: true,
    callout: {
      targetId: "calendar-event-form",
      text: CALENDAR_SCRIPT_COPY.calEventForm.callout,
    },
    durationMs: 5400,
  },
  {
    id: "cal-post-form",
    narrative: CALENDAR_SCRIPT_COPY.calPostForm.narrative,
    zoomTargetId: "calendar-post-form",
    disableZoom: true,
    callout: {
      targetId: "calendar-post-form",
      text: CALENDAR_SCRIPT_COPY.calPostForm.callout,
    },
    durationMs: 5000,
  },
  {
    id: "cal-overview",
    narrative: CALENDAR_SCRIPT_COPY.calOverview.narrative,
    durationMs: 2000,
  },
  {
    id: "cal-sidebar",
    narrative: CALENDAR_SCRIPT_COPY.calSidebar.narrative,
    zoomTargetId: "calendar-sidebar",
    callout: {
      targetId: "calendar-sidebar",
      text: CALENDAR_SCRIPT_COPY.calSidebar.callout,
    },
    durationMs: 5400,
  },
  {
    id: "cal-outro",
    narrative: CALENDAR_SCRIPT_COPY.calOutro.narrative,
    durationMs: 2800,
  },
];
